import React, {Fragment, useState} from "react";
import {Button, ButtonContent} from "semantic-ui-react";
import {useNavigate} from "react-router-dom";
import dartsLogo from "../../img/DartsLogo.png"
import snookerLogo from "../../img/SnookerLogo.png"
import tennisLogo from "../../img/TennisLogo.png"
import "./Main.scss";
import styles from "./Main.module.scss"
import MainTopButtons from "../../components/Buttons/MainTopButtons/MainTopButtons";
import BannerCarousel from "../../components/BannerCarousel/BannerCarousel";
import * as R from "../../common/routes";

const Main = () => {
    const navigate = useNavigate()
    const [scheduleStats, setScheduleStats] = useState({visible: false});

    const getDartsInitData = () => {
        setScheduleStats({
            ...scheduleStats,
            visible: !scheduleStats.visible,
        });
        navigate(R.DARTS_EVENT_MANAGER)
    };

    return (
        <Fragment>
            <MainTopButtons/>
            <div className="schedule__container">
                <div className={styles.sportInitButtons}>
                    <div className="schedule__sports">
                        <Button className="sport-select-btn" secondary onClick={getDartsInitData}>
                            <img src={dartsLogo} alt="logo"/>
                        </Button>
                    </div>
                    <div className="schedule__sports">
                        <Button className="sport-select-btn" secondary animated='fade'>
                            <ButtonContent visible>
                                <img src={tennisLogo} alt="logo"/>
                            </ButtonContent>
                            <ButtonContent hidden>not for Demo</ButtonContent>
                        </Button>
                    </div>
                    <div className="schedule__sports">
                        <Button className="sport-select-btn" secondary animated='fade'>
                            <ButtonContent visible>
                                <img src={snookerLogo} alt="logo" />
                            </ButtonContent>
                            <ButtonContent hidden>not for Demo</ButtonContent>
                        </Button>
                    </div>
                </div>
                <div className={styles.bannerCarousel}>
                    <BannerCarousel/>
                </div>
            </div>
        </Fragment>
    );
};

export default Main;
Main.displayName = "Schedule";
